<template>
    <div class="config-stock-one">
        <div class="config-stock-card rounder-8 mb-4">
            <!-- Header -->
            <div class="product-info-header">
                <span class="product-sku-badge">{{ propHead.row.sku }}</span>
                <span class="product-name-text">{{ propHead.row.long_name }}</span>
            </div>

            <!-- Campos de configuración -->
            <div class="stock-fields-container">
                <div class="stock-field">
                    <label class="stock-field-label">DÍAS DE COBERTURA MÍNIMOS</label>
                    <div class="input-with-suffix">
                        <input 
                            type="number" 
                            class="stock-input" 
                            v-model.number="coverageDaysMin"
                            min="0"
                            step="1"
                            :class="{ 'input-error': coverageDaysMin > coverageDaysMax }"
                        />
                        <span class="input-suffix">días</span>
                    </div>
                </div>

                <div class="stock-field">
                    <label class="stock-field-label">DÍAS DE COBERTURA MÁXIMOS</label>
                    <div class="input-with-suffix">
                        <input 
                            type="number" 
                            class="stock-input" 
                            v-model.number="coverageDaysMax"
                            min="0"
                            step="1"
                        />
                        <span class="input-suffix">días</span>
                    </div>
                </div>

                <div class="stock-field">
                    <label class="stock-field-label">SITUACIÓN DE STOCK</label>
                    <div class="input-with-suffix">
                        <select
                            class="stock-input stock-select"
                            v-model="stockSituation"
                        >
                            <option value="">No definido</option>
                            <option value="quiebre">Quiebre</option>
                            <option value="sobrestock">Sobrestock</option>
                        </select>
                        <span class="input-suffix">situación</span>
                    </div>
                </div>

                <div class="stock-field">
                    <label class="stock-field-label">ACCIÓN DE PRECIO</label>
                    <div class="input-with-suffix">
                        <select
                            class="stock-input stock-select"
                            v-model="priceAction"
                        >
                            <option value="" disabled>Seleccione una opción</option>
                            <option
                                v-for="option in priceActionOptions"
                                :key="option.value"
                                :value="option.value"
                            >
                                {{ option.label }}
                            </option>
                        </select>
                        <span class="input-suffix">acción</span>
                    </div>
                </div>

                <div class="stock-field">
                    <label class="stock-field-label">% DE AJUSTE</label>
                    <div class="input-with-suffix">
                        <input 
                            type="number" 
                            class="stock-input" 
                            v-model.number="priceAdjustmentPercentage"
                            step="0.1"
                        />
                        <span class="input-suffix">%</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Botones de acción -->
        <div class="d-flex justify-content-end gap-2">
            <button class="btn btn-success fw-400 px-4" @click="saveStock" :disabled="saving">
                <span v-if="saving">Guardando...</span>
                <span v-else>Guardar</span>
            </button>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'config-stock-one',
    props: {
        propHead: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            coverageDaysMin: 0,
            coverageDaysMax: 0,
            stockSituation: '',
            priceAction: '',
            priceActionOptions: [
                { value: 'Subir el precio para desacelerar venta', label: 'Subir el precio para desacelerar venta' },
                { value: 'Bajar el precio para acelerar rotacion', label: 'Bajar el precio para acelerar rotacion' },
                { value: 'Solo alerta, sin accion', label: 'Solo alerta, sin accion' },
            ],
            priceAdjustmentPercentage: 0,
            saving: false,
        };
    },
    created() {
        this.loadCurrentValues();
    },
    methods: {
        ...mapActions(['update']),
        loadCurrentValues() {
            const row = this.propHead.row;
            if (row) {
                this.coverageDaysMin = row.coverage_days_min !== null && row.coverage_days_min !== undefined ? parseFloat(row.coverage_days_min) : 0;
                this.coverageDaysMax = row.coverage_days_max !== null && row.coverage_days_max !== undefined ? parseFloat(row.coverage_days_max) : 0;
                this.stockSituation = row.stock_situation || '';
                this.priceAction = row.price_Action || row.price_action || '';
                this.priceAdjustmentPercentage = row.price_adjustment_percentage !== null && row.price_adjustment_percentage !== undefined ? parseFloat(row.price_adjustment_percentage) : 0;
            }
        },
        saveStock() {
            if (this.coverageDaysMin > this.coverageDaysMax) {
                this.$notification.error('Los días de cobertura mínimos no pueden ser mayores a los días máximos.', { timer: 5, showCloseIcn: true });
                return;
            }
            this.saving = true;
            const row = this.propHead.row;
            const data = {
                id: row.id,
                coverage_days_min: this.coverageDaysMin,
                coverage_days_max: this.coverageDaysMax,
                price_action: this.priceAction,
                price_adjustment_percentage: this.priceAdjustmentPercentage,
                stock_situation: this.stockSituation,
            };
            this.update({
                url: `/api/products/config_stock/update/`,
                params: data,
            }).then(() => {
                this.saving = false;
                this.$emit('refrest');
                this.$notification.success('Configuración de stock actualizada correctamente.', { timer: 5, showCloseIcn: true });
            }).catch((error) => {
                this.saving = false;
                if (error.status == 400) {
                    this.$notification.error(error.data.message || 'Error al guardar la configuración.', { timer: 5, showCloseIcn: true });
                } else {
                    this.$notification.error('Error al guardar la configuración.', { timer: 5, showCloseIcn: true });
                }
            });
        },
    }
};
</script>

<style scoped>
.config-stock-card {
    background: #ffffff;
}

.product-info-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 0;
    margin-bottom: 16px;
}

.product-sku-badge {
    display: inline-block;
    background: #f3f4f6;
    color: #6b7280;
    font-size: 0.75rem;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 4px;
    white-space: nowrap;
}

.product-name-text {
    font-size: 0.9rem;
    font-weight: 500;
    color: #374151;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.stock-fields-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.stock-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.stock-field-label {
    font-size: 0.75rem;
    font-weight: 600;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.03em;
}

.input-with-suffix {
    display: flex;
    align-items: center;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    overflow: hidden;
    background: #ffffff;
    transition: border-color 0.2s ease;
}

.input-with-suffix:focus-within {
    border-color: #1AA179;
    box-shadow: 0 0 0 0.2rem rgba(26, 161, 121, 0.15);
}

.stock-input {
    flex: 1;
    border: none !important;
    outline: none !important;
    padding: 10px 12px;
    font-size: 0.95rem;
    color: #1f2937;
    background: transparent;
    box-shadow: none !important;
}

.stock-select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    cursor: pointer;
}

.stock-input::placeholder {
    color: #9ca3af;
}

.stock-input.input-error {
    color: #dc3545;
}

.input-suffix {
    padding: 10px 12px;
    background: #f3f4f6;
    color: #6b7280;
    font-size: 0.82rem;
    font-weight: 500;
    white-space: nowrap;
    border-left: 1px solid #e5e7eb;
}

.btn-success {
    background-color: #1AA179 !important;
    border-color: #1AA179 !important;
}

.btn-success:hover:not(:disabled) {
    background-color: #158a65 !important;
    border-color: #158a65 !important;
}

.btn-success:disabled {
    opacity: 0.65;
}
</style>
